import { render, staticRenderFns } from "./TransferOnlineReservationModal.vue?vue&type=template&id=15f91670&lang=pug"
import script from "./TransferOnlineReservationModal.vue?vue&type=script&lang=ts"
export * from "./TransferOnlineReservationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports